import { type Href } from 'expo-router';
import { Image } from 'react-native';

import { Button } from '@/components/ui/Button';
import { Surface } from '@/components/ui/Surface';
import { BILLING_ENABLED, FREE_RUN_LIMIT, FREE_TEMPLATE_LIMIT } from '@/lib/billing';
import { SIGNUP_OPEN } from '@/lib/constants';

import { Body } from './Body';
import { Display } from './Display';
import { Section } from './Section';

export function FinalCta({ getStartedHref }: { getStartedHref: Href }) {
  return (
    <Section className="py-16">
      <Surface variant="ink" className="items-center rounded-[28px] px-10 py-16">
        <Image
          source={require('../../../../assets/images/brand-mark.png')}
          resizeMode="cover"
          className="mb-6"
          style={{ width: 56, height: 56, borderRadius: 14 }}
        />
        <Display className="mb-4 text-center text-[44px] leading-[1.04] tracking-[-0.025em] text-on-ink">
          Nothing left on the ground.
        </Display>
        <Body className="mb-8 max-w-[48ch] text-center text-[17px] leading-[1.6] text-faint">
          Build and run your first checklist in just minutes.
          {BILLING_ENABLED
            ? ` Free for ${FREE_TEMPLATE_LIMIT} checklists and ${FREE_RUN_LIMIT} runs, no card required.`
            : ''}{' '}
          iOS, Android, and web support.
        </Body>
        {SIGNUP_OPEN ? (
          <Button size="lg" label="Start now, it's free!" href={getStartedHref} />
        ) : (
          <Button size="lg" label="Coming soon" disabled />
        )}
      </Surface>
    </Section>
  );
}
